export default __webpack_public_path__ + "static/media/daugava.9540acc7.jpg";